import Axios from "../../../../util/Axios";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1ProjectMilestoneAuditHistoryIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class ProjectMilestoneAuditHistoryEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectMilestoneSession-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": "v1.ProjectMilestoneSession-001",
                "-id": uuidv4(),
                "ProjectMilestoneSession": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "ProjectMilestoneAuditHistory": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }

        Axios({
            method: "GET",
            url: "t8/v1/project_milestone_sessions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectMilestoneAuditHistoryIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ProjectMilestoneAuditHistoryEnterpriseComponent;